import { Pipe, PipeTransform } from '@angular/core';
import { Category } from '@interfaces/Category';
import { DepartmentEstimate } from '@interfaces/DepartmentEstimate';

@Pipe({
  name: 'internalFeeCost'
})
export class InternalFeeCostPipe implements PipeTransform {
  public transform(element: DepartmentEstimate | Category): number {
    return element.estimateLines.reduce(
      (billable, estimateLine) =>
        billable +
        estimateLine.internalFeeLines.map(l => l.quantity * l.rateCost).reduce((sum, element) => sum + element, 0),
      0
    );
  }
}
